import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class LearningResourceRecord extends PureComponent {
  render() {
    const WIDTH = 216;
    const HEIGHT = 168;

    const {
      publication: {
        id,
        name,
        image_retina: imageRetina,
        image_default: imageDefault,
        learning_resource_type_name: learningResourceType,
        url,
      },
    } = this.props;

    return (
      <div className="m-record-results__item">
        {(imageRetina || imageDefault) && (
          <figure className="m-record-results__figure">
            <a
              href={url}
              className="m-image-link m-record-results__image-link"
              aria-hidden="true"
            >
              <div className="m-image">
                <img
                  className="m-image__img m-record-results__img"
                  src={imageDefault}
                  srcSet={`${imageRetina} ${
                    WIDTH * 2
                  }w, ${imageDefault} ${WIDTH}w`}
                  sizes={`(max-width: 620px) 148px, 100vw`}
                  width={WIDTH}
                  height={HEIGHT}
                  alt={""}
                  loading="lazy"
                />
              </div>
            </a>
          </figure>
        )}
        <div className="m-record-results__body">
          {learningResourceType && (
            <div className="t-copy-label m-record-results__label">
              {learningResourceType}
            </div>
          )}
          {name && <p className="m-record-results__text">{name}</p>}
          {url && <a href={url}>Read More</a>}
        </div>
      </div>
    );
  }
}

LearningResourceRecord.propTypes = {
  publication: PropTypes.object,
};

export default LearningResourceRecord;
